var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSatisfaction = function SvgSatisfaction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "satisfaction_svg__a",
    d: "M12.96 13.49A3.045 3.045 0 0 0 16 10.45V4.04A3.044 3.044 0 0 0 12.96 1H3.04A3.043 3.043 0 0 0 0 4.04v10.61c0 .547.323 1.037.83 1.24.165.069.34.11.52.11.355 0 .702-.146.95-.4l2.11-2.11z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "satisfaction_svg__b",
    width: 16,
    height: 15,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#satisfaction_svg__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14864D",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#satisfaction_svg__a",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeWidth: 3.333,
    mask: "url(#satisfaction_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.034 8.034a.8.8 0 0 1 1.124-.008l.061.052.088.064c.25.168.81.458 1.693.458.895 0 1.458-.3 1.703-.466l.085-.063.132-.11a.805.805 0 0 1 1.277.659.8.8 0 0 1-.248.562l-.101.09-.11.089-.068.05-.16.107-.195.116C9.822 9.91 9.051 10.2 8 10.2s-1.822-.29-2.315-.566l-.195-.116-.084-.056-.144-.102-.11-.087-.118-.107a.8.8 0 0 1 0-1.132M5.6 4.6a.8.8 0 1 1 0 1.6.8.8 0 0 1 0-1.6m4.8 0a.8.8 0 1 1 0 1.6.8.8 0 0 1 0-1.6"
  })))));
};
export default SvgSatisfaction;